async function request(path, options = {}) {
  const response = await fetch(`/api${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload.error?.message ?? `HTTP ${response.status}`);
    error.status = response.status;
    error.details = payload.error?.details;
    throw error;
  }
  return payload.data ?? payload;
}

function queryString(params) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && value !== 'all') query.set(key, value);
  });
  const text = query.toString();
  return text ? `?${text}` : '';
}

export const api = {
  login: (body) => request('/auth/login', { method: 'POST', body: JSON.stringify(body) }),
  feishuConfig: () => request('/auth/feishu/config'),
  feishuStatus: () => request('/auth/feishu/status'),
  session: () => request('/auth/session'),
  logout: () => request('/auth/logout', { method: 'POST' }),
  changePassword: (body) => request('/auth/change-password', { method: 'POST', body: JSON.stringify(body) }),
  health: () => request('/health'),
  videos: (params) => request(`/videos${queryString(params)}`),
  videoStats: () => request('/videos/stats'),
  dashboard: () => request('/dashboard'),
  video: (id) => request(`/videos/${id}`),
  snapshots: (id, params = {}) => request(`/videos/${id}/snapshots${queryString(params)}`),
  updateVideo: (id, body) => request(`/videos/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  archiveVideo: (id) => request(`/videos/${id}/archive`, { method: 'POST' }),
  restoreVideo: (id) => request(`/videos/${id}/restore`, { method: 'POST' }),
  previewImport: (links, productId) => request('/videos/import/preview', { method: 'POST', body: JSON.stringify({ links, productId: productId ?? undefined }) }),
  confirmImport: (links, productId) => request('/videos/import/confirm', { method: 'POST', body: JSON.stringify({ links, productId }) }),
  refreshVideo: (id) => request(`/videos/${id}/refresh`, { method: 'POST' }),
  refreshVideos: (videoIds, triggerType = 'manual_batch') => request('/videos/refresh', {
    method: 'POST',
    body: JSON.stringify({ videoIds, triggerType }),
  }),
  tasks: (params = {}) => request(`/tasks${queryString(params)}`),
  task: (id) => request(`/tasks/${id}`),
  logs: (params = {}) => request(`/logs${queryString(params)}`),
  creators: () => request('/creators'),
  createCreator: (profileUrl) => request('/creators', { method: 'POST', body: JSON.stringify({ profileUrl }) }),
  setVideoCreator: (id, creatorAccountId, mode = 'manual') => request(`/videos/${id}/creator`, {
    method: 'PUT',
    body: JSON.stringify({ creatorAccountId, mode }),
  }),
  products: () => request('/products'),
  createProduct: (name) => request('/products', { method: 'POST', body: JSON.stringify({ name }) }),
  updateProduct: (id, name) => request(`/products/${id}`, { method: 'PATCH', body: JSON.stringify({ name }) }),
  setVideoProduct: (id, productId) => request(`/videos/${id}/product`, {
    method: 'PUT',
    body: JSON.stringify({ productId }),
  }),
  settings: () => request('/settings/collection'),
  updateSettings: (body) => request('/settings/collection', { method: 'PUT', body: JSON.stringify(body) }),
  feishuSettings: () => request('/integrations/feishu'),
  updateFeishuSettings: (body) => request('/integrations/feishu', { method: 'PUT', body: JSON.stringify(body) }),
  syncFeishu: () => request('/integrations/feishu/sync', { method: 'POST' }),
};
